import axiosInstance from "@/api/axios-instance";

export async function updateUsageBundle(usage_id: string, new_bundle_id: string) {
  const response = await axiosInstance.patch(`/usage/${usage_id}/bundle`, {
    bundle_id: new_bundle_id,
  });

  if (!response.status.toString().startsWith("2")) {
    throw new Error("Failed to update usage bundle");
  }

  return response.data;
}
